import { Controller } from '@hotwired/stimulus';

export class ParamsController extends Controller {
  static targets = [ 'control', 'link' ];
  static values = {
    linkAttribute: {
      default: 'href',
      type: String,
    },
  };

  connect() {
    this.setAll();
  }

  set(event) {
    const {
      name = event.target.name,
      value = event.target.multiple
        ? [...event.target.selectedOptions].map(option => option.value)
        : event.target.value,
    } = event.params;

    if (this.hasLinkTarget) return this.#setLinkParams({ [name]: value });

    this.#pushHistory(this.#setParam(window.location.href, name, value));
  }

  setAll() {
    if (!this.hasControlTarget) return;

    const params = {};

    this.controlTargets.forEach(control => {
      if (control.type === 'checkbox') {
        if (!control.checked) return;

        params[control.name] ||= [];
        params[control.name].push(control.value);
      } else {
        params[control.name] = control.multiple
          ? [...control.selectedOptions].map(option => option.value)
          : control.value;
      }
    });

    if (this.hasLinkTarget) return this.#setLinkParams(params);

    this.#pushHistory(this.#setParams(window.location.href, params));
  }

  #pushHistory(url) {
    window.history.pushState(window.history.state, null, url);
  }

  #setLinkParams(params) {
    this.linkTargets.forEach(link => link.setAttribute(
      this.linkAttributeValue,
      this.#setParams(link.getAttribute(this.linkAttributeValue), params)
    ));
  }

  #setParam(url, name, value) {
    const newUrl = new URL(url);

    newUrl.searchParams.delete(name);

    if (!value) return newUrl.toString();

    if (Array.isArray(value)) {
      value.forEach(v => v && newUrl.searchParams.append(name, v));
    } else {
      newUrl.searchParams.set(name, value);
    }

    return newUrl.toString();
  }

  #setParams(url, params) {
    let newUrl = new URL(url);

    Object.keys(params).forEach(param => newUrl = this.#setParam(newUrl, param, params[param]));

    return newUrl.toString();
  }
}
